import {TradingAlertRuleType} from "./TradingAlertRuleType";

export interface TradingAlertRule {
    readonly type: TradingAlertRuleType;
}

export interface PriceAlertRule extends TradingAlertRule {
    type: TradingAlertRuleType.PRICE;
    priceAbove: number | null;
    priceBelow: number | null;
    pricePercentMove: number | null;
}

export interface AdxAlertRule extends TradingAlertRule {
    type: TradingAlertRuleType.ADX;
    adxAbove: number | null;
    adxBelow: number | null;
}

export function isPriceRule(rule: TradingAlertRule): rule is PriceAlertRule {
    return "type" in rule && rule.type === TradingAlertRuleType.PRICE;
}

export function isAdxRule(rule: TradingAlertRule): rule is AdxAlertRule {
    return "type" in rule && rule.type === TradingAlertRuleType.ADX;
}
